<template>
  <card
    dis-hover
    class="law-cases-item"
    :padding="8"
    @click.native="openLawCase"
  >
    <div class="law-cases-item__main">
      <div class="law-cases-item__common-info">
        <div class="law-cases-item__statuses">
          <tag :color="getLawCaseStatusColor(lawCase.law_status_name)">
            {{ lawCase.law_status_name }}
          </tag>
        </div>
        <div class="law-cases-item__members">
          <div class="law-cases-item__member ms-text">
            Заявитель: <b>{{ lawCase.applicant_name }}</b>
          </div>
          <div class="law-cases-item__member ms-text">
            Ответчик: <b>{{ lawCase.defendant_name }}</b>
          </div>
        </div>
      </div>
      <div class="law-cases-item__dates">
        <span class="ms-help">
          Начало:
          {{
            lawCase.start_date
              ? formatDefaultDate(lawCase.start_date)
              : "Не указано"
          }}
        </span>
        <span class="ms-help">
          Окончание:
          {{
            lawCase.end_date
              ? formatDefaultDate(lawCase.end_date)
              : "Не указано"
          }}
        </span>
      </div>
      <div class="law-cases-item__costs">
        <tag color="default" style="margin-right: 8px; flex-shrink: 0;">
          {{ lawCase.from_own_company ? "От компании" : "На компанию" }}
        </tag>
        <tag class="ms-costs" color="primary">
          {{ getFormattedCosts(lawCase.costs, false, lawCase.with_vat) }}
        </tag>
      </div>
    </div>
    <div class="law-cases-item__result" v-if="lawCase.law_case_stages && lawCase.law_case_stages.length">
      <span class="ms-help">
        Последнее событие: {{ resultText }}
      </span>
    </div>
  </card>
</template>

<script>
import {
  getFormattedCosts,
  getLawCaseStatusColor,
  formatDefaultDate
} from '@/utils'

export default {
  props: ['law-case', 'all'],
  computed: {
    resultText () {
      const { law_case_stages } = this.lawCase
      const lastEvent = law_case_stages[law_case_stages.length - 1]

      if (!lastEvent) return null

      const { start_date, end_date, name, result } = lastEvent

      return `${start_date || end_date || 'Дата не указана'} - ${name} (${result || 'Результат не указан'})`
    }
  },
  methods: {
    openLawCase () {
      if (this.all) this.$store.commit('SET_COME_FROM', 'law-cases')

      this.$emit('open-law-case', {
        id: this.lawCase.id,
        contract_id: this.lawCase.contract_id
      })
    },
    getLawCaseStatusColor,
    getFormattedCosts,
    formatDefaultDate
  }
}
</script>

<style lang="less">
.law-cases-item {
  margin-bottom: 4px;
  cursor: pointer;

  .ivu-tag {
    margin: 0;
  }

  &:hover {
    border-color: rgba(@primary-color, 0.6) !important;
  }

  &__main {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__result {
    margin-top: 8px;
  }

  &__common-info {
    width: 50%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }

  &__statuses {
    .ivu-tag {
      margin-right: 0;
      width: 100px;
      text-align: center;
    }
  }

  &__members {
    display: flex;
    margin-left: 16px;
  }

  &__member {
    &:first-child {
      margin-right: 16px;
    }
  }

  &__costs {
    display: flex;

    .ivu-tag {
      margin: 0;
    }
  }

  &__dates {
    .ms-help:first-child {
      margin-right: 8px;
    }
  }
}
</style>
